import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    lockscreenList: []
}

const mutations = {
    SET_LOCKSCREEN_DETAILS(state, lockscreenData) {
        var tData = {};
        var parseData = lockscreenData.message;
        if (Object.keys(state.lockscreenList).length == 0) {
            tData[lockscreenData.accountId + '-lockscreenList'] = parseData;
            state.lockscreenList = tData;
        } else {
            Vue.set(state.lockscreenList, lockscreenData.accountId + '-lockscreenList', parseData);
        }
    },
}

const actions = {
    fetchLockScreenDetails({
        commit
    }, authData) {
        return new Promise((resolve, reject) => {
            Nprogress.start()
            axios.get("/lock_screen/index/true")
                .then(response => {
                    Nprogress.done()
                    resolve(response.data);
                    commit('SET_LOCKSCREEN_DETAILS', response.data)
                })
                .catch(error => console.log(error));
        });
    },
    lockScreenSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/lock_screen/index/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}

const getters = {
    lockScreenGetters: state => {
        return state.lockscreenList;
    },
}


export default {
    state,
    mutations,
    actions,
    getters
}